import * as React from "react";
import {
    Edit,
    FormTab,
    NumberInput,
    ReferenceInput,
   
    required,
    SelectInput,
    TabbedForm,
    TextInput,
    ImageField,
    BooleanInput,
    ImageInput,
   
} from "react-admin";
import { InputAdornment } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";






const ItemsTitle = ({ record }) => {
    return record ? <span>Item #{record.name}</span> : null;
};

const useStyles = makeStyles({
    MuiFilledInput:{
       root:{
        backgroundColor: "white",
       } 
    },
    comment: {
        maxWidth: "20em",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    tab: {
        maxWidth: "40em",
        display: "block",
    },
});



export const ItemEdit = (props) => {
    const classes = useStyles();
    return (
        <Edit {...props} title={<ItemsTitle />}>
            <TabbedForm>
                <FormTab label="image" contentClassName={classes.tab}>
                    <ImageInput source="images" label="Related pictures" multiple={true} accept="image/*">
                        <ImageField source="img" title="Item Image" />
                    </ImageInput>
                </FormTab>
                <FormTab label="details" path="details" contentClassName={classes.tab}>
                    <TextInput source="name" validate={requiredValidate} />
                    <TextInput source="color" validate={requiredValidate} />
                    <TextInput source="condition" validate={requiredValidate} />
                    <NumberInput
                        source="sale_price"
                        InputProps={{
                            endAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        validate={requiredValidate}
                    />
                    <NumberInput
                        source="daily_rent_price"
                        
                        InputProps={{
                            endAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        validate={requiredValidate}
                    />
                    <NumberInput source="min_renting_period" className={classes.width}  validate={requiredValidate} />
                    <NumberInput
                        size="medium"
                        source="width"
                        className={classes.width}
                        formClassName={classes.widthFormGroup}
                        InputProps={{
                            endAdornment: <InputAdornment position="start">cm</InputAdornment>,
                        }}
                        validate={requiredValidate}
                    />
                    <NumberInput
                        source="height"
                        className={classes.height}
                        formClassName={classes.heightFormGroup}
                        InputProps={{
                            endAdornment: <InputAdornment position="start">cm</InputAdornment>,
                        }}
                        validate={requiredValidate}
                    />
                    <NumberInput
                        source="depth"
                        formClassName={classes.heightFormGroup}
                        InputProps={{
                            endAdornment: <InputAdornment position="start">cm</InputAdornment>,
                        }}
                        validate={requiredValidate}
                    />
                    <NumberInput source="rate" />
                    <ReferenceInput
                    
                        source="category_id"
                        label="Category Name"
                        reference="categories"
                        validate={requiredValidate}
                    >
                        <SelectInput fullWidth={true} className={classes} optionText="category_name"  />
                    </ReferenceInput>
                </FormTab>
                <FormTab label="description" path="description" contentClassName={classes.tab}>
                    <TextInput source="description" label="" validate={requiredValidate} />
                </FormTab>
                <FormTab label="Status" path="Status">
                    <BooleanInput source="is_for_sale" />
                    <BooleanInput source="is_for_rent" />
                    <BooleanInput source="is_rented" />
                    <BooleanInput source="is_procured" />
                </FormTab>
                <FormTab label="Address" path="Address">
                    <TextInput source="address_one" className={classes.stock} validate={requiredValidate} />
                    <TextInput source="address_two" className={classes.stock} validate={requiredValidate} />
                    <TextInput source="city" className={classes.stock} validate={requiredValidate} />
                    <TextInput source="state" className={classes.stock} validate={requiredValidate} />
                    <TextInput source="zipcode" className={classes.stock} validate={requiredValidate} />
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

const requiredValidate = [required()];
